// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Int from "@rescript/core/src/Core__Int.mjs";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactRouterJs from "./vendor/react-router.js";

function setParamOpt(t, key, value) {
  if (value !== undefined) {
    t.set(key, Caml_option.valFromOption(value));
  } else {
    t.delete(key);
  }
}

function setParamArray(t, key, value) {
  t.delete(key);
  value.forEach(function (value) {
        t.append(key, value);
      });
}

function setParamArrayOpt(t, key, value) {
  if (value !== undefined) {
    return setParamArray(t, key, value);
  } else {
    t.delete(key);
    return ;
  }
}

function toString(t) {
  var search = t.toString();
  if (search === "") {
    return "";
  } else {
    return "?" + search;
  }
}

function toStringStable(t) {
  t.sort();
  return toString(t);
}

function decodeValue(value) {
  return value.split(",").map(function (v) {
              return decodeURIComponent(v);
            });
}

function parse(search) {
  if (!search.includes(",")) {
    return new URLSearchParams(search);
  }
  var t = new URLSearchParams();
  var search$1 = search.startsWith("?") ? search.slice(1) : search;
  var parts = search$1.split("&");
  parts.forEach(function (part) {
        var keyValue = part.split("=");
        var match = keyValue[0];
        var match$1 = keyValue[1];
        if (match !== undefined && match$1 !== undefined) {
          return setParamArray(t, match, decodeValue(match$1));
        }
        
      });
  return t;
}

function getArrayParamByKey(t, key) {
  var array = t.getAll(key);
  if (array.length !== 0) {
    return array;
  }
  
}

function getParamInt(parsedParams, key) {
  var raw = parsedParams.get(key);
  if (!(raw == null)) {
    return Core__Int.fromString(raw, undefined);
  }
  
}

function getParamBool(parsedParams, key) {
  var match = parsedParams.get(key);
  if (match == null) {
    return ;
  }
  switch (match) {
    case "false" :
        return false;
    case "true" :
        return true;
    default:
      return ;
  }
}

var $$URL = {};

function applyPayload(t, entry) {
  var response = entry.response;
  if (response === undefined) {
    return ;
  }
  var $$final = entry.final;
  if ($$final !== undefined) {
    t.next(response);
    if ($$final) {
      t.complete();
      return ;
    } else {
      return ;
    }
  }
  
}

var RelayReplaySubject = {
  applyPayload: applyPayload
};

function generatePath(prim0, prim1) {
  return ReactRouterJs.generatePath(prim0, prim1);
}

function QueryParams_make(prim) {
  return new URLSearchParams();
}

function QueryParams_setParam(prim0, prim1, prim2) {
  prim0.set(prim1, prim2);
}

function QueryParams_deleteParam(prim0, prim1) {
  prim0.delete(prim1);
}

function QueryParams_getParamByKey(prim0, prim1) {
  return Caml_option.nullable_to_opt(prim0.get(prim1));
}

var QueryParams = {
  make: QueryParams_make,
  setParam: QueryParams_setParam,
  setParamOpt: setParamOpt,
  setParamArray: setParamArray,
  setParamArrayOpt: setParamArrayOpt,
  setParamInt: setParamOpt,
  setParamBool: setParamOpt,
  deleteParam: QueryParams_deleteParam,
  toString: toString,
  toStringStable: toStringStable,
  parse: parse,
  getParamByKey: QueryParams_getParamByKey,
  getArrayParamByKey: getArrayParamByKey,
  getParamInt: getParamInt,
  getParamBool: getParamBool
};

export {
  QueryParams ,
  $$URL ,
  RelayReplaySubject ,
  generatePath ,
}
/* ./vendor/react-router.js Not a pure module */
